import { Injectable } from '@angular/core';
import {
	ActivatedRoute,
	ActivatedRouteSnapshot,
	CanActivate,
	NavigationEnd,
	PRIMARY_OUTLET,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private router: Router, private authService: AuthService, private activatedRoute: ActivatedRoute) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return this.authService.isAuthenticated().then((resp: any) => {
			if (!resp) {
				this.router.navigate(['/login']);
			}
			
			// tes validate access
			// this.router.events
			// .pipe(filter(event => event instanceof NavigationEnd))
			// .pipe(map(() => this.activatedRoute))
			// .pipe(
			// 	map(route => {
			// 		while (route.firstChild) {
			// 			route = route.firstChild;
			// 		}
			// 		return route;
			// 	})
			// )
			// .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
			// .subscribe(route => {
			// 	if (route) {
			// 		const user = JSON.parse(localStorage.getItem('EWPadmin.user'));
			// 		const data = route.snapshot.data['role'];
			// 		// if (user.role.includes(data)) {
						
			// 		// } else {
			// 		// 	this.router.navigate(['/404']);
			// 		// }
			// 	}
			// });

			return true;
		});
	}
}
